// Module
var code = "<div ref=\"referenceListContainer\" class=\"overflow-auto\">\n    <cjs-smart-select ref=\"smartSelect\"></cjs-smart-select>\n    <div ref=\"selectedValuesContainer\" class=\"flex-container-column\">\n        <cjs-smart-table ref=\"selectedValuesTable\"></cjs-smart-table>\n    </div>\n</div>";
// Exports
module.exports = code;